import { render, staticRenderFns } from "./SectionModal.vue?vue&type=template&id=ca05044e&scoped=true&"
import script from "./SectionModal.vue?vue&type=script&lang=js&"
export * from "./SectionModal.vue?vue&type=script&lang=js&"
import style0 from "./SectionModal.vue?vue&type=style&index=0&id=ca05044e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca05044e",
  null
  
)

export default component.exports